import { useV2GetPromptOverrideQuery } from "@generated";
import { PromptOverrideFormState } from "../types";

const useGetPromptOverride = (id: string) => {
  const { data, error, isLoading, refetch } = useV2GetPromptOverrideQuery({
    id,
    include: ["open-router-key"],
  });

  let promptOverride: PromptOverrideFormState | null = null;
  let customError: string | null = null;

  if (data?.data) {
    try {
      const resource = data.data;
      if (!resource.id) {
        throw new Error("Missing prompt override id");
      }

      const attrs = resource.attributes as Record<string, any> | undefined;
      if (!attrs) {
        throw new Error("Missing attributes");
      }

      const rels = resource.relationships as Record<string, any> | undefined;
      const openRouterKeyId = rels?.["open-router-key"]?.data?.id;

      promptOverride = {
        id: String(resource.id),
        promptType: attrs["prompt-type"] || "",
        content: attrs["content"] || "",
        model: Array.isArray(attrs["model"]) ? attrs["model"] : [],
        openRouterKeyId: openRouterKeyId ? String(openRouterKeyId) : "",
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    promptOverride,
    error: error || customError,
    isLoading,
    refetch,
  };
};

export default useGetPromptOverride;
